var exports = {
  "wx": "AvatarDecorationPicker.module__header___V3dJaX",
  "DD": "AvatarDecorationPicker.module__title___V3dJaX",
  "h_": "AvatarDecorationPicker.module__description___V3dJaX",
  "hZ": "AvatarDecorationPicker.module__trigger___V3dJaX",
  "lE": "AvatarDecorationPicker.module__triggerPreview___V3dJaX",
  "FR": "AvatarDecorationPicker.module__avatarStandIn___V3dJaX",
  "_3": "AvatarDecorationPicker.module__triggerCopy___V3dJaX",
  "am": "AvatarDecorationPicker.module__triggerName___V3dJaX",
  "r8": "AvatarDecorationPicker.module__triggerCaption___V3dJaX",
  "DX": "AvatarDecorationPicker.module__triggerAction___V3dJaX",
};

module.exports = exports;
